import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const FlatItem = ({
  slug,
  header,
  katha,
  location,
  building,
  parking,
  noOfFlat,
  sizeOfFlat,
  lift,
  parkingDesc,
  roofFacilities,
}) => {
  // Animation variants for container and child elements
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <div className="text-center col-lg-6 col-12 col-md-6 mb-5">
      <div className="item shadow-lg rounded overflow-hidden bg-white">
        {/* Image */}
        <div className="item-image">
          <img
            className="img-fluid w-100"
            src={
              slug === "gemstone-primero"
                ? "/img/GemstoneCalalgoPrimero2.jpg"
                : "/img/building.jpg"
            }
            alt={header}
          />
        </div>

        {/* Animated Text Section */}
        <motion.div
          className="item-description p-4 text-start"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <motion.div
            variants={itemVariants}
            className="d-flex justify-content-between mb-3 border-b pb-2"
          >
            <span className="item-title text-xl font-bold">{header}</span>
            <span className="text-sm font-semibold">{katha}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-map-marker-alt text-primary"></i>
            <span className="pl-2">{location}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">{building}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Flats: {noOfFlat}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Size of Flats: {sizeOfFlat}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Lift: {lift}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Parkings: {parking}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Parking: {parkingDesc}</span>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-1 text-xs">
            <i className="fas fa-check-circle text-success"></i>
            <span className="pl-2">Roof facilities: {roofFacilities}</span>
          </motion.div>

          <motion.div
            variants={itemVariants}
            className="mt-2 d-flex justify-content-between align-items-center"
          >
            <div>
              <i className="fas fa-check-circle text-success"></i>
              <span className="pl-2">
                Developer: Gemstone Real Estate Limited.
              </span>
            </div>
            <Link to={`/flat/${slug}`}>
              <button className="btn btn-detail ms-3">View</button>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default FlatItem;
